import { basicPath } from '../basicPath';

export const fetchMembersAll = (params) => async (dispatch) => {
    const path = '/member-users/all';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchMembersIds = (params) => async (dispatch) => {
    const path = '/member-users/ids';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchMembersMpPermissions = (params) => async (dispatch) => {
    const path = '/member-users/mp-permissions';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchMembersRpPermissions = (params) => async (dispatch) => {
    const path = '/member-users/rp-permissions';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const createMember = (params) => async (dispatch) => {
    // IMPORTANT: MathPlex Nginx redirects `/member-users` -> `/member-users/` with a 301.
    // Browsers/axios can convert redirected POST/DELETE into a GET, causing `404 undefined`.
    // Always hit the canonical trailing-slash URL to avoid redirect.
    const path = '/member-users/';
    const type = 'post';
    return await basicPath(dispatch, params, path, type);
}

export const updateMember = (params) => async (dispatch) => {
    const path = '/member-users/all';
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const updateMemberPassword = (params) => async (dispatch) => {
    const path = '/member-users/password';
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const resendMemberWelcome = (params) => async (dispatch) => {
    const path = '/member-users/resend-welcome';
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const deleteMember = (params) => async (dispatch) => {
    // See note in createMember() about Nginx 301 redirect behavior.
    const path = '/member-users/';
    const type = 'delete';
    return await basicPath(dispatch, params, path, type);
}